export default __webpack_public_path__ + "static/media/rightArrow.bf1fda3f.svg";